module.exports = __webpack_public_path__ + "img/DJI_0026.bc34ff69.jpg";